import { Box, Image, Stack, Text } from '@chakra-ui/react';
import { QuizQuestionJson } from '~/monolith-api';
import { CorrectQuizQuestionIcon, IncorrectQuizQuestionIcon } from '.';

type ImagePickerQuestionProps = {
   question: QuizQuestionJson;
   markUserResponse: boolean;
   markCorrectAnswer: boolean;
   userResponse?: string | null;
   correctAnswer?: string;
   isCorrect?: boolean;
};

export const ImagePicker = ({
   question,
   markUserResponse,
   markCorrectAnswer,
   userResponse,
   correctAnswer,
   isCorrect,
}: ImagePickerQuestionProps) => {
   const response = userResponse ? JSON.parse(userResponse) : null;
   const answer = correctAnswer ? JSON.parse(correctAnswer) : null;

   const getQuestionIcon = (value: string) => {
      if (markUserResponse) {
         if (value === response && isCorrect) {
            return <CorrectQuizQuestionIcon />;
         } else if (value === response && !isCorrect) {
            return <IncorrectQuizQuestionIcon />;
         }
      } else if (markCorrectAnswer) {
         if (value === answer) {
            return <CorrectQuizQuestionIcon />;
         }
      }
      return '';
   };

   return (
      <Box>
         {question.choices?.map(choice => {
            let value,
               imageLink = '';
            if (typeof choice === 'string') {
               value = choice;
               imageLink = choice;
            } else {
               value = choice.value;
               imageLink = choice.imageLink;
            }
            return (
               <Stack
                  key={question.name}
                  direction="row"
                  maxWidth="400px"
                  p="6px"
                  bgColor={markUserResponse && response === value ? '#e8f1fd' : 'transparent'}
               >
                  <Text width="16px">{getQuestionIcon(value)}</Text>
                  <Image src={imageLink} alt={question.name} />
               </Stack>
            );
         })}
      </Box>
   );
};
